var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorisFilterNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 18C31.7188 14.1212 30.2207 10.4013 27.5542 7.65856C24.8876 4.91584 21.271 3.375 17.5 3.375C13.729 3.375 10.1124 4.91584 7.44583 7.65856C4.77929 10.4013 3.28125 14.1212 3.28125 18C3.28125 21.8788 4.77929 25.5987 7.44583 28.3414C10.1124 31.0842 13.729 32.625 17.5 32.625C21.271 32.625 24.8876 31.0842 27.5542 28.3414C30.2207 25.5987 31.7188 21.8788 31.7188 18ZM0 18C0 13.2261 1.84374 8.64773 5.12563 5.27208C8.40752 1.89642 12.8587 0 17.5 0C22.1413 0 26.5925 1.89642 29.8744 5.27208C33.1563 8.64773 35 13.2261 35 18C35 22.7739 33.1563 27.3523 29.8744 30.7279C26.5925 34.1036 22.1413 36 17.5 36C12.8587 36 8.40752 34.1036 5.12563 30.7279C1.84374 27.3523 0 22.7739 0 18Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_321_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9946 3C18.5058 3 18.9724 3.30469 19.1946 3.79102L23.0058 12.0703L31.5169 13.3945C32.0169 13.4707 32.4335 13.8398 32.5891 14.3496C32.7446 14.8594 32.6169 15.4102 32.2613 15.7852L26.0891 22.2422L27.5446 31.3594C27.628 31.8867 27.4224 32.4199 27.0058 32.7363C26.5891 33.0527 26.0446 33.0879 25.6002 32.8359L17.9891 28.5469L10.3891 32.8301C9.93909 33.082 9.39464 33.0469 8.98353 32.7305C8.57242 32.4141 8.36131 31.8809 8.44464 31.3535L9.9002 22.2363L3.72798 15.7852C3.36686 15.4102 3.24464 14.8535 3.4002 14.3496C3.55575 13.8457 3.97242 13.4766 4.47242 13.3945L12.9835 12.0703L16.7946 3.79102C17.0224 3.30469 17.4835 3 17.9946 3ZM17.9946 7.62891L15.078 13.9688C14.8835 14.3848 14.5113 14.6777 14.0724 14.748L7.5002 15.7676L12.2724 20.7539C12.578 21.0762 12.7224 21.5332 12.6502 21.9844L11.5224 28.998L17.3669 25.7051C17.7613 25.4824 18.2335 25.4824 18.6224 25.7051L24.4669 28.998L23.3446 21.9902C23.2724 21.5391 23.4113 21.082 23.7224 20.7598L28.4946 15.7734L21.9224 14.748C21.4891 14.6777 21.1113 14.3906 20.9169 13.9688L17.9946 7.62891Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_1463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_321_1463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorisFilterNotSelected);
export default __webpack_public_path__ + "static/media/FavorisFilterNotSelected.623fc2468b23698c06840b8a1b17a901.svg";
export { ForwardRef as ReactComponent };